import React from "react";
import { Button } from "./tailwind";
import { showMessage } from "../utils/partialUtils";
import { NotificationAppearance } from "../api/djangoToastSlice";

type Size = "lg" | "sm";

type TextCopyButtonProps = {
  text: string;
  size?: Size;
  className?: string;
};

export const TextCopyButton: React.FC<TextCopyButtonProps> = ({
  text,
  size,
  className,
}) => {
  const handleClick = async (): Promise<void> => {
    try {
      await navigator.clipboard.writeText(text);
    } catch (e) {
      showMessage(NotificationAppearance.ERROR, "Error copying to clipboard");
      return;
    }
    showMessage(NotificationAppearance.SUCCESS, "Copied to clipboard");
  };

  return (
    <Button
      iconOnly
      size={size}
      compact="very"
      borderless
      onClick={handleClick}
      className={className || ""}
    >
      <i className="material-icons">content_copy</i>
    </Button>
  );
};
